import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import clsx from "clsx";
import { Alert, Button, Form, TextField } from '@curves/ui-base';

import { GradientColorHeader } from "@Local/Components/Dialog";
import useOrderCyclePurchaseApi from "@Apis/useOrderCyclePurchaseApi";
import { refIsRequiredError } from "@Util/utils";
const CyclePurchaseCancelDialogContent = forwardRef((props, ref) => {
	const leaveReasonRef = useRef(null);
	useImperativeHandle(
		ref,
		() => ({
			getResult: () => {
				let result = {};
				if (leaveReasonRef.current && leaveReasonRef.current.getResult) {
					result.leaveReason = leaveReasonRef.current.getResult();
				}
				return result;
			},
			isErrors: () => refIsRequiredError([leaveReasonRef]),
		}),
		// eslint-disable-next-line
		[]
	);
	return (
		<DialogContent>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<TextField ref={leaveReasonRef} label={"退訂原因補充說明"} placeholder="例如: 過卡失敗次數已達三次。" fullWidth required multiline rows={1} />
				</Grid>
				<Grid item xs={12}>
					<Alert color={"info"} severity={"info"} variant={"outlined"} className="my-2">
						請執行退訂前，確認該主單是否符合退訂條件（例如：過卡失敗次數已達三次）， 或已於「退訂總覽」完成確認後，再進行退訂作業流程，謝謝。
					</Alert>
				</Grid>
			</Grid>
		</DialogContent>
	);
});
const CyclePurchaseCancelDialog = props => {
	const { postOrdersCyclePurchasePaymentErrorsApi } = useOrderCyclePurchaseApi();
	const { open = false, sourceData, refresh, onClose, className } = props;
	const contentRef = useRef(null);
	const handleSubmit = e => {
		const isError = contentRef.current.isErrors();
		if (!isError) {
			const result = contentRef.current.getResult();
			doPostOrdersCyclePurchasePaymentErrorsApi(sourceData.cycleOrderID, result);
		}
	};
    const doPostOrdersCyclePurchasePaymentErrorsApi = async (cycleOrderID, result) => {
        const response = await postOrdersCyclePurchasePaymentErrorsApi(cycleOrderID, result);
        if (response && response.success !== false) {
            refresh();
            onClose();
        }
    };
	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-65rem", component: Form }} open={open} onSubmit={handleSubmit} fullWidth>
			<GradientColorHeader onClose={onClose}>確定要退訂嗎？</GradientColorHeader>
			<CyclePurchaseCancelDialogContent ref={contentRef} />
			<DialogActions>
				<Button variant="contained" color="primary" type="submit">
					確認退訂
				</Button>
			</DialogActions>
		</Dialog>
	);
};
export default CyclePurchaseCancelDialog;
